const productTitle = document.querySelector("h1.product-title").innerHTML;

function initFit() {
  renderFit();
}

async function renderFit() {
  let query = productTitle;
  let fitType = "Standard"; // default

  // Detect type of actual Fit
  if (productTitle.toLowerCase().includes("extended")) {
    query = productTitle.split("Extended")[0].trim();
    fitType = "Extended";
  } else if (productTitle.toLowerCase().includes("petites")) {
    query = productTitle.split("Petites")[0].trim();
    fitType = "Petites";
  }

  try {
    let suggestions = await fetch(
      `${window.Shopify.routes.root}search/suggest.json?q=${query}&resources[type]=product&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title`
    );
    suggestions = await suggestions.json();
    suggestions = suggestions.resources.results.products;

    // Search alternative versions
    const relatedFits = {
      Standard: suggestions.find(
        (p) =>
          !p.title.toLowerCase().includes("extended") &&
          !p.title.toLowerCase().includes("petites")
      ),
      Extended: suggestions.find((p) =>
        p.title.toLowerCase().includes("extended")
      ),
      Petites: suggestions.find((p) =>
        p.title.toLowerCase().includes("petites")
      ),
    };

    // Only render the selector if there's at least one other version
    const hasOtherFits = Object.entries(relatedFits).some(([key, product]) => key !== fitType && product);
    if (hasOtherFits) {
        createFitSelector(fitType, relatedFits);
    }
  } catch (error) {
    console.error("Error rendering fit selector:", error);
  }
}

function createFitSelector(currentFit, relatedFits) {
  const containers = document.querySelectorAll(".fieldset.custom-fit");

  const fits = ["Standard", "Extended", "Petites"];
  const buttons = fits
    .filter((fit) => fit === currentFit || relatedFits[fit])
    .map((fit) => {
      const isChecked = currentFit === fit ? "checked" : "";
      const onClick =
        currentFit === fit
          ? ""
          : `onclick="window.open('${relatedFits[fit].url}', '_self')"`;
      return `
                <input type="radio" id="custom-${fit.toLowerCase()}-input" name="Fit" value="${fit}" ${isChecked}>
                <label for="custom-${fit.toLowerCase()}-input" ${onClick}>
                    <span>${fit}</span>
                </label>
            `;
    })
    .join("\n");

  const HTML = `
    <div class="product-form__input product-form__input--block custom-fit">
        <div class="form__label">Fit: <span class="form__label__value">${currentFit}</span></div>
        ${buttons}
    </div>
    `;

  containers.forEach((container) => {
    container.insertAdjacentHTML("afterend", HTML);
    container.remove();
  });
}

initFit();
